import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Dumbo/EditorDumbo';
const ImageThumbView = (props)=>{
    /* In editor we make the background transparent to avoid overlapping with custom backgrounds */ return /*#__PURE__*/ React.createElement(MinimalDumbo, _object_spread({
        useBackgroundColor: false
    }, props));
};
ImageThumbView.displayName = 'ImageThumbView';
export default ImageThumbView;

//# sourceMappingURL=Image.js.map